import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PortalShell } from "../components/PortalShell";
import { portal } from "../lib/api";
import { PasswordRequirements, passwordOk } from "../components/PasswordRequirements";

export default function PortalSetPasswordPage() {
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const pwOk = passwordOk(password);
  const mismatch = confirm.length > 0 && confirm !== password;

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) {
      setError("This link is missing its token. Request a new one from the sign-in page.");
      return;
    }
    if (!pwOk) {
      setError("Please meet all the password requirements below.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await portal.setPassword(token, password);
      // setPassword signs the client straight in.
      nav("/portal/dashboard");
    } catch (e: any) {
      setError(
        e?.message ||
          "This link is invalid or expired. Request a new one from the sign-in page.",
      );
      setBusy(false);
    }
  }

  return (
    <PortalShell narrow>
      <div className="portal-login">
        <div className="portal-login-card">
          <p className="portal-eyebrow on-card" style={{ margin: 0 }}>Almost there</p>
          <h1>Set your password</h1>
          <p className="portal-sub on-card">
            Choose a password for your secure client portal. You'll use it with
            your email to sign in from now on.
          </p>
          <form onSubmit={submit} className="portal-section" style={{ gap: 14, marginTop: 6 }}>
            <label className="portal-section" style={{ gap: 6 }}>
              <span className="field-label">New password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                placeholder="At least 8 characters"
                required
              />
              <PasswordRequirements password={password} />
            </label>
            <label className="portal-section" style={{ gap: 6 }}>
              <span className="field-label">Confirm password</span>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                placeholder="Re-enter your password"
                required
              />
              {mismatch && <span className="portal-error">Passwords don't match.</span>}
            </label>
            {error && <p className="portal-error">{error}</p>}
            <button
              className="portal-btn-primary wide"
              disabled={busy || !pwOk || password !== confirm}
            >
              {busy ? "Saving…" : "Save password & sign in"}
            </button>
          </form>
        </div>
      </div>
    </PortalShell>
  );
}
